import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import { styled } from '../../utils';
import { FormFlex } from '../FormGrid';
export function StepNavigationLayout({ children }) {
    return (_jsx(StyledFormFlex, { justifyContent: Children.count(children) > 1 ? 'space-between' : 'flex-end', align: "center", rowGap: 2, columnGap: 2, children: children }));
}
const StyledFormFlex = styled(FormFlex)(({ theme }) => ({
    backgroundColor: theme.palette.info.main,
    position: 'sticky',
    bottom: 0,
    padding: theme.spacing(2, 0),
    zIndex: 1,
}));
